"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Filter.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : TextFilter.js
* Description : Ce fichier contient la définition du composant TextFilter 
*               Ce composant est un champ texte pour réaliser un filtrage en fonction de la valeur saisie
* Date de création : 4 octobre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* TextFilter : affiche un champ texte pour réaliser un filtrage en fonction de la valeur saisie
*
* Type : composant 
*
* Parametres : 
*  - label -- texte affiché au dessus du champ pour apporter des précisions
*  - value -- valeur saisie
*  - setValue -- fonction pour mettre à jour la variable value
*/function TextFilter(_ref) {
  var label = _ref.label,
    value = _ref.value,
    setValue = _ref.setValue;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "text-label flex-column",
    children: [label, ":", /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      className: "text-input",
      type: "text",
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      }
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
TextFilter.propTypes = {
  label: _propTypes["default"].string,
  value: _propTypes["default"].string,
  setValue: _propTypes["default"].func
};
var _default = exports["default"] = TextFilter;